// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-ai-fab {
  position: fixed;
  right: 1.25rem;
  bottom: 1.25rem;
  z-index: 1050;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #1d3557;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.portal-ai-fab:hover {
  background: #274c77;
}

.portal-ai-widget {
  --pai-ink: #1a1a1a;
  --pai-muted: #6c757d;
  --pai-line: rgba(0, 0, 0, 0.08);
  --pai-surface: #f4f6f8;
  position: fixed;
  z-index: 1049;
  background: #fff;
  border: 1px solid var(--pai-line);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 14px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  color: var(--pai-ink);
  max-height: calc(100vh - 2rem);
}

.portal-ai-widget--hidden {
  display: none;
}

.portal-ai-widget--floating {
  right: 1.25rem;
  bottom: 5rem;
  width: min(360px, calc(100vw - 1.5rem));
  min-height: 420px;
  max-height: min(640px, calc(100vh - 6rem));
  border-radius: 0.35rem;
}

.portal-ai-widget--dock-right {
  top: 0;
  right: 0;
  bottom: 0;
  width: min(360px, 100vw);
  max-height: 100vh;
  border-radius: 0;
}

/* Keep invoice action cells clear while retaining the assistant on the page. */
.portal-ai-widget--invoices.portal-ai-widget--floating {
  right: auto;
  left: 1.25rem;
}

.portal-ai-widget--invoices.portal-ai-widget--dock-right {
  right: auto;
  left: 0;
}

.portal-ai-widget__header {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 0.85rem;
  border-bottom: 1px solid var(--pai-line);
  background: var(--pai-surface);
}

.portal-ai-widget__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
}

.portal-ai-widget__subtitle {
  font-size: 0.7rem;
  color: var(--pai-muted);
}

.portal-ai-widget__header-actions {
  margin-left: auto;
  display: flex;
  gap: 0.15rem;
}

.portal-ai-widget__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--pai-line);
  align-items: center;
}

.portal-ai-widget__toolbar .form-control {
  flex: 1 1 8rem;
  min-width: 0;
}

.portal-ai-widget__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0.65rem 0.75rem;
  min-height: 12rem;
}

.portal-ai-widget__empty {
  margin: 0.5rem 0;
}

.portal-ai-widget__turn {
  margin-bottom: 0.85rem;
}

.portal-ai-widget__q,
.portal-ai-widget__a {
  font-size: 0.85rem;
  margin-bottom: 0.35rem;
}

.portal-ai-widget__q strong,
.portal-ai-widget__a strong {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--pai-muted);
  margin-bottom: 0.15rem;
}

.portal-ai-widget__a-expand {
  --pai-answer-cap: 320px;
  margin: 0.15rem 0 0;
}

.portal-ai-widget__a-body {
  font-size: 0.85rem;
  background: var(--pai-surface);
  border: 1px solid var(--pai-line);
  border-radius: 0.25rem;
  padding: 0.45rem 0.55rem;
  max-height: var(--pai-answer-cap);
  overflow: hidden;
}

.portal-ai-widget__a-body.is-expanded {
  max-height: none;
  overflow: visible;
}

.portal-ai-widget__a-body.is-clamped {
  mask-image: linear-gradient(to bottom, #000 72%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, #000 72%, transparent 100%);
}

.portal-ai-widget__a-more {
  display: block;
  margin-top: 0.2rem;
  padding: 0;
  border: 0;
  background: none;
  color: #1d3557;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
}

.portal-ai-widget__a-more:hover {
  text-decoration: underline;
}

.portal-ai-widget__composer {
  display: flex;
  padding: 0.55rem 0.65rem;
  border-top: 1px solid var(--pai-line);
  background: var(--pai-surface);
}

.portal-ai-widget__field {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.15rem;
  min-width: 0;
  padding: 0.2rem 0.25rem 0.2rem 0.55rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.35rem;
  background: #fff;
}

.portal-ai-widget__field:focus-within {
  border-color: #1d3557;
  box-shadow: 0 0 0 0.12rem rgba(29, 53, 87, 0.15);
}

.portal-ai-widget__input {
  flex: 1 1;
  min-width: 0;
  resize: none;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 0.875rem;
  line-height: 1.4;
  padding: 0.35rem 0.15rem;
  outline: none;
  box-shadow: none;
}

.portal-ai-widget__input::placeholder {
  color: var(--pai-muted);
}

.portal-ai-widget__submit {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0.25rem;
  background: transparent;
  color: #1d3557;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
}

.portal-ai-widget__submit:hover:not(:disabled) {
  background: transparent;
  opacity: 0.85;
}

.portal-ai-widget__submit:focus-visible {
  outline: 2px solid rgba(29, 53, 87, 0.45);
  outline-offset: 1px;
}

.portal-ai-widget__submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.portal-ai-answer {
  font-size: 0.85rem;
  line-height: 1.45;
}

.portal-ai-answer p {
  margin: 0 0 0.5rem;
}

.portal-ai-answer p:last-child {
  margin-bottom: 0;
}

.portal-ai-answer ul,
.portal-ai-answer ol {
  margin: 0 0 0.5rem;
  padding-left: 1.2rem;
}

.portal-ai-cite {
  font-size: inherit;
  vertical-align: baseline;
  white-space: normal;
}

.portal-ai-nav {
  font-weight: 600;
}

@media (max-width: 576px) {
  .portal-ai-widget--floating {
    right: 0.5rem;
    left: 0.5rem;
    width: auto;
    bottom: 4.5rem;
  }

  .portal-ai-widget--invoices.portal-ai-widget--floating {
    right: 0.5rem;
    left: 0.5rem;
    width: min(280px, calc(100vw - 1rem));
  }

  .portal-ai-widget--invoices.portal-ai-widget--dock-right {
    width: min(280px, 70vw);
  }
}
`, "",{"version":3,"sources":["webpack://./src/platform/ai/portalAiWidget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,wEAAwE;EACxE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kEAAkE;EAClE,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".portal-ai-fab {\n  position: fixed;\n  right: 1.25rem;\n  bottom: 1.25rem;\n  z-index: 1050;\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #1d3557;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.portal-ai-fab:hover {\n  background: #274c77;\n}\n\n.portal-ai-widget {\n  --pai-ink: #1a1a1a;\n  --pai-muted: #6c757d;\n  --pai-line: rgba(0, 0, 0, 0.08);\n  --pai-surface: #f4f6f8;\n  position: fixed;\n  z-index: 1049;\n  background: #fff;\n  border: 1px solid var(--pai-line);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 14px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  color: var(--pai-ink);\n  max-height: calc(100vh - 2rem);\n}\n\n.portal-ai-widget--hidden {\n  display: none;\n}\n\n.portal-ai-widget--floating {\n  right: 1.25rem;\n  bottom: 5rem;\n  width: min(360px, calc(100vw - 1.5rem));\n  min-height: 420px;\n  max-height: min(640px, calc(100vh - 6rem));\n  border-radius: 0.35rem;\n}\n\n.portal-ai-widget--dock-right {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(360px, 100vw);\n  max-height: 100vh;\n  border-radius: 0;\n}\n\n/* Keep invoice action cells clear while retaining the assistant on the page. */\n.portal-ai-widget--invoices.portal-ai-widget--floating {\n  right: auto;\n  left: 1.25rem;\n}\n\n.portal-ai-widget--invoices.portal-ai-widget--dock-right {\n  right: auto;\n  left: 0;\n}\n\n.portal-ai-widget__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.75rem 0.85rem;\n  border-bottom: 1px solid var(--pai-line);\n  background: var(--pai-surface);\n}\n\n.portal-ai-widget__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.portal-ai-widget__subtitle {\n  font-size: 0.7rem;\n  color: var(--pai-muted);\n}\n\n.portal-ai-widget__header-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 0.15rem;\n}\n\n.portal-ai-widget__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid var(--pai-line);\n  align-items: center;\n}\n\n.portal-ai-widget__toolbar .form-control {\n  flex: 1 1 8rem;\n  min-width: 0;\n}\n\n.portal-ai-widget__body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 0.65rem 0.75rem;\n  min-height: 12rem;\n}\n\n.portal-ai-widget__empty {\n  margin: 0.5rem 0;\n}\n\n.portal-ai-widget__turn {\n  margin-bottom: 0.85rem;\n}\n\n.portal-ai-widget__q,\n.portal-ai-widget__a {\n  font-size: 0.85rem;\n  margin-bottom: 0.35rem;\n}\n\n.portal-ai-widget__q strong,\n.portal-ai-widget__a strong {\n  display: block;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--pai-muted);\n  margin-bottom: 0.15rem;\n}\n\n.portal-ai-widget__a-expand {\n  --pai-answer-cap: 320px;\n  margin: 0.15rem 0 0;\n}\n\n.portal-ai-widget__a-body {\n  font-size: 0.85rem;\n  background: var(--pai-surface);\n  border: 1px solid var(--pai-line);\n  border-radius: 0.25rem;\n  padding: 0.45rem 0.55rem;\n  max-height: var(--pai-answer-cap);\n  overflow: hidden;\n}\n\n.portal-ai-widget__a-body.is-expanded {\n  max-height: none;\n  overflow: visible;\n}\n\n.portal-ai-widget__a-body.is-clamped {\n  mask-image: linear-gradient(to bottom, #000 72%, transparent 100%);\n  -webkit-mask-image: linear-gradient(to bottom, #000 72%, transparent 100%);\n}\n\n.portal-ai-widget__a-more {\n  display: block;\n  margin-top: 0.2rem;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #1d3557;\n  font-size: 0.72rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.portal-ai-widget__a-more:hover {\n  text-decoration: underline;\n}\n\n.portal-ai-widget__composer {\n  display: flex;\n  padding: 0.55rem 0.65rem;\n  border-top: 1px solid var(--pai-line);\n  background: var(--pai-surface);\n}\n\n.portal-ai-widget__field {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.15rem;\n  min-width: 0;\n  padding: 0.2rem 0.25rem 0.2rem 0.55rem;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.35rem;\n  background: #fff;\n}\n\n.portal-ai-widget__field:focus-within {\n  border-color: #1d3557;\n  box-shadow: 0 0 0 0.12rem rgba(29, 53, 87, 0.15);\n}\n\n.portal-ai-widget__input {\n  flex: 1;\n  min-width: 0;\n  resize: none;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  padding: 0.35rem 0.15rem;\n  outline: none;\n  box-shadow: none;\n}\n\n.portal-ai-widget__input::placeholder {\n  color: var(--pai-muted);\n}\n\n.portal-ai-widget__submit {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0.25rem;\n  background: transparent;\n  color: #1d3557;\n  font-size: 1.25rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.portal-ai-widget__submit:hover:not(:disabled) {\n  background: transparent;\n  opacity: 0.85;\n}\n\n.portal-ai-widget__submit:focus-visible {\n  outline: 2px solid rgba(29, 53, 87, 0.45);\n  outline-offset: 1px;\n}\n\n.portal-ai-widget__submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.portal-ai-answer {\n  font-size: 0.85rem;\n  line-height: 1.45;\n}\n\n.portal-ai-answer p {\n  margin: 0 0 0.5rem;\n}\n\n.portal-ai-answer p:last-child {\n  margin-bottom: 0;\n}\n\n.portal-ai-answer ul,\n.portal-ai-answer ol {\n  margin: 0 0 0.5rem;\n  padding-left: 1.2rem;\n}\n\n.portal-ai-cite {\n  font-size: inherit;\n  vertical-align: baseline;\n  white-space: normal;\n}\n\n.portal-ai-nav {\n  font-weight: 600;\n}\n\n@media (max-width: 576px) {\n  .portal-ai-widget--floating {\n    right: 0.5rem;\n    left: 0.5rem;\n    width: auto;\n    bottom: 4.5rem;\n  }\n\n  .portal-ai-widget--invoices.portal-ai-widget--floating {\n    right: 0.5rem;\n    left: 0.5rem;\n    width: min(280px, calc(100vw - 1rem));\n  }\n\n  .portal-ai-widget--invoices.portal-ai-widget--dock-right {\n    width: min(280px, 70vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
